import { callPostApi } from '../apiCallerProxy';
import { favoritedMediaItemsApiFactory } from './favoritedMediaItemsApiFactory';

export default favoritedMediaItemsApiFactory({ callPostApi });
